import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { gql } from '@/__generated__';
import { StreamSubscriptionCancelInput } from '@/__generated__/graphql.ts';

const CancelStreamSubscription = gql(`
  mutation CancelStreamSubscription($input: StreamSubscriptionCancelInput!) {
    streamSubscriptionCancel(input: $input) {
      cancelAt
      active
    }
  }
`);

export const useCancelStreamSubscription = (streamId: string) => {
  const toast = useToast();

  const [cancelStreamSubscriptionMutation, result] = useMutation(
    CancelStreamSubscription,
    {
      onError: () => {
        toast.error({
          title: 'Failed to cancel subscription',
          subTitle: 'Please try again',
        });
      },

      update(cache, result) {
        const subscription = result.data?.streamSubscriptionCancel;
        if (subscription?.cancelAt) {
          cache.modify({
            id: `Stream:${streamId}`,
            fields: {
              subscription: (existing) => ({
                ...existing,
                cancelAt: subscription.cancelAt,
                active: subscription.active,
              }),
            },
          });
        }
      },
    },
  );

  const cancelStreamSubscription = (input: StreamSubscriptionCancelInput) => {
    return cancelStreamSubscriptionMutation({
      variables: {
        input,
      },
    });
  };

  return [cancelStreamSubscription, result] as const;
};
